module.exports = function() {
  return new Worker(__webpack_public_path__ + "5b6656483171d3361bb4.worker.js");
};